import { useState } from "react";
import { useTranslation } from "react-i18next";
import BackButtonWrapper from "../../../components/button/BackButton/wrapper";
import OverStayedVisitorsReportTable from "../../../components/table/OverStayedVisitorsReportTable";
import SearchOverstayedVisitorsReportCard from "../../../components/card/SearchOverstayedVisitorsReportCard";
import { ExportOverStayedVisitorsReportForExcelPDFBody } from "../../../hooks/report/interface";
import { PAGE_SIZE } from "../../../constants/common";

const OverStayedVisitorsReport = () => {
  const { t } = useTranslation();

  const [exportBody, setExportBody] =
    useState<ExportOverStayedVisitorsReportForExcelPDFBody>();
  const [page, setPage] = useState<number>(1);
  const [pages, setPages] = useState(1);
  const [count, setCount] = useState(0);
  const [pageSize, setPageSize] = useState<number>(PAGE_SIZE);
  const [search, setSearch] = useState("");

  const [allVisitors, setAllVisitors] = useState([]);

  return (
    <div className="flex flex-col gap-4 md:gap-8">
      <BackButtonWrapper>
        <h1 className="text-xl md:text-2xl dark:text-white">
          {t("overstayedVisitorsReport")}
        </h1>
      </BackButtonWrapper>

      <SearchOverstayedVisitorsReportCard
        setAllVisitors={setAllVisitors}
        page={page}
        search={search}
        setPages={setPages}
        setCount={setCount}
        setExportBody={setExportBody}
        pageSize={pageSize}
        setPage={setPage}
      />

      <OverStayedVisitorsReportTable
        allVisitors={allVisitors}
        page={page}
        pages={pages}
        setPage={setPage}
        search={search}
        setSearch={setSearch}
        count={count}
        exportBody={exportBody}
        pageSize={pageSize}
        setPageSize={setPageSize}
      />
    </div>
  );
};

export default OverStayedVisitorsReport;
